import * as yup from "yup";

import { CommunicationBaseFormType } from "@/components/organisms/Forms/Communication/formType";
import { Shape } from "@/core/yup";

export const formSchemaCommunication = yup.object<{}, Shape<CommunicationBaseFormType>>({
    phone0: yup.string().phone().nullable(),
    phone1: yup.string().phone().nullable(),
    phone2: yup.string().phone().nullable(),

    email0: yup.string().email().nullable(),
    email1: yup.string().email().nullable(),
});
